import schema from 'generated/schema.json';
import { createClient, dedupExchange } from 'urql';
import { multipartFetchExchange } from '@urql/exchange-multipart-fetch';
import { devtoolsExchange } from '@urql/devtools';
import { cacheExchange, UpdateResolver } from '@urql/exchange-graphcache';
import { relayPagination } from '@urql/exchange-graphcache/extras';
import { env } from 'config/env';
import { mutationCacheUpdates } from './cacheUpdates';

const url = env?.REACT_APP_API_URL as string;

type UpdateResolverRecord = { [fieldName: string]: UpdateResolver };

const relayPaginationStrategy = relayPagination();
const getExchanges = () => {
  let exchanges = [
    dedupExchange,
    cacheExchange({
      schema: schema as any,
      resolvers: {
        Query: {
          findBaseQueriesPage: (parent, fieldArgs, cache, info) => {
            // invalidates all pages in case filter is requested from page 0
            if (!parent.response && !fieldArgs.after) {
              const key = 'Query';
              cache
                .inspectFields(key)
                .filter((field) => field.fieldName === 'findBaseQueriesPage')
                .forEach((field) => {
                  cache.invalidate(key, field.fieldKey);
                });
            }
            return relayPaginationStrategy(parent, fieldArgs, cache, info);
          }
        }
      },
      updates: {
        Mutation: mutationCacheUpdates as UpdateResolverRecord
      },
      keys: {
        SearchFilterField: () => null,
        ColumnConfig: () => null,
        BaseQueryPage: () => null
      }
    }),
    multipartFetchExchange
  ];

  if (process.env.NODE_ENV !== 'production') {
    exchanges = [devtoolsExchange, ...exchanges];
  }

  return exchanges;
};

export const createUrqlClient = (accessToken: string, customFetch: typeof fetch = fetch) =>
  createClient({
    url,
    fetchOptions: {
      headers: {
        authorization: `Bearer ${accessToken}`,
        'apollo-require-preflight': 'true'
      }
    },
    exchanges: getExchanges(),
    fetch: customFetch
  });
